import { DAppKitProvider } from "@mysten/dapp-kit-react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";

import { dAppKit } from "@/lib/sui/dappKit";

import { SuiDappKitContextControllerProps } from "./SuiDappKitContext.types";

/**
 * dapp-kit v2 replaces v1's `SuiClientProvider` + `WalletProvider` pair with a
 * single `DAppKitProvider` that just publishes the instance from
 * `@/lib/sui/dappKit` over context — all configuration lives there.
 *
 * v2 has no react-query dependency of its own, but `QueryClientProvider` stays:
 * our chain reads (`hooks/sui/queries.ts`) are plain react-query hooks now.
 */
export const SuiDappKitContextController = ({ children }: SuiDappKitContextControllerProps) => {
  // Keep one QueryClient for the lifetime of the app — a client created inline
  // is thrown away on every render, which silently discards the cache.
  const [queryClient] = React.useState(() => new QueryClient());

  return (
    <QueryClientProvider client={queryClient}>
      <DAppKitProvider dAppKit={dAppKit}>{children}</DAppKitProvider>
    </QueryClientProvider>
  );
};
